<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="miter" aria-hidden="true">
    <circle cx="11" cy="11" r="7"/>
    <line x1="16" y1="16" x2="21" y2="21"/>
  </svg>
</template>
